import cx from 'classnames'
import * as React from 'react'

import type { ProcedurePreviewStepViewModel } from '../../view-models/ProcedurePreviewStepViewModel'
import Carousel from '../Carousel/Carousel'
import MediaQuery from '../MediaQuery/MediaQuery'
import ProcedurePreviewStep from '../ProcedurePreviewStep/ProcedurePreviewStep'
import styles from './procedurePreviewGrid-style.css'

type Props = {
  items: Array<ProcedurePreviewStepViewModel>
  startingPoint?: number

  /** needed for dataLayer **/
  moduleName?: string
}
type State = {}

class ProcedurePreviewGrid extends React.Component<Props, State> {
  static displayName = 'ProcedurePreviewGrid'
  static defaultProps = {}

  render() {
    const { items, startingPoint, moduleName } = this.props
    if (!items) return null
    let start = 1
    if (startingPoint) start = startingPoint

    return (
      <MediaQuery defaultMatches={true} query={'(min-width: 992px )'}>
        {(matches) =>
          matches ? (
            <div className={cx(styles.procedurePreview, 'procedurePreview')}>
              {items.length < 4 ? (
                items.map((item, index) => (
                  <ProcedurePreviewStep
                    key={index}
                    className={styles.step}
                    index={index + start}
                    {...item}
                  />
                ))
              ) : (
                <Carousel
                  key={moduleName}
                  moduleName={moduleName}
                  slidesToShow={3.2}
                  slidesToScroll={3}
                  items={items.slice(0, items.length)}
                  renderItems={(items) => {
                    return items
                      .slice(0, items.length)
                      .map((item, index) => (
                        <ProcedurePreviewStep
                          className={styles.step}
                          key={index}
                          {...item}
                          index={index + start}
                        />
                      ))
                  }}
                />
              )}
            </div>
          ) : (
            <div className={cx(styles.procedurePreviewMobile, 'procedurePreview')}>
              <Carousel
                key={moduleName}
                moduleName={moduleName}
                items={items.slice(0, items.length)}
                renderItems={(items) => {
                  return items
                    .slice(0, items.length)
                    .map((item, index) => (
                      <ProcedurePreviewStep
                        className={styles.step}
                        key={index}
                        {...item}
                        index={index + start}
                      />
                    ))
                }}
              />
            </div>
          )
        }
      </MediaQuery>
    )
  }
}

export default ProcedurePreviewGrid